import { useResponsiveContext } from '@psl/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { ActivityIndicator, StyleProp, View, ViewStyle } from 'react-native';

export const DefaultLoadingIndicator: FC<{
  style?: StyleProp<ViewStyle>;
  size?: 'small' | 'large' | 'default';
}> = memo(({ style, size = 'default' }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={style}
      css={`
        margin: auto;
        background: rgba(0, 0, 0, 0.3);
        border-radius: ${rpx(8)}px;
        overflow: hidden;
        padding: ${rpx(15)}px;
      `}
    >
      <ActivityIndicator
        color={'white'}
        size={size === 'default' ? undefined : size}
      />
    </View>
  );
});
